import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import FeeSchedule from "../../../../Utility/Crud/FeeSchedule";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminFeeScheduleList extends CardClass {
    static contextType = MainContext; // For legacy class components

    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number"},
                    { key: "hcpcsCodeId", name: "HCPCS Code", type: "hcpcsCode"},
                    { key: "modifierCodeId", name: "Modifier Code", type: "modifierCode"},
                    { key: "amount", name: "Amount", type: "currency", width: "150px" },
                ]}
                rows={FeeSchedule.sort(Object.values(this.context.feeSchedulesIndexed))}
                onClick={(feeSchedule) => {
                    this.props.history.push({
                        pathname: "/admin/feeSchedule/" + feeSchedule.id
                    });
                }}
            />
        );
    }
});